import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import "./Header.css";
import "./HeaderAdmin.css";

interface HeaderProps {
  activeSection?: string;
}

const Header: React.FC<HeaderProps> = ({ activeSection }) => {
  const [forceUserMode, setForceUserMode] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isEmbed,
    logout,
    isAuthenticated,
    hasAdminPermission,
    hasManagerPermission,
    hasSystemPermission,
    isInitialized,
  } = useMembership();

  // 관리자 페이지인지 확인
  const isAdminPage = useCallback(() => {
    return location.pathname.startsWith("/admin");
  }, [location.pathname]);

  // 관리자 페이지 접근 시 강제 사용자 모드 해제
  useEffect(() => {
    if (isAdminPage()) {
      setForceUserMode(false);
    }
  }, [isAdminPage]);

  // 관리자 모드인지 확인 (강제 사용자 모드 상태 고려)
  const isAdminMode = () => {
    // console.log('isAdminMode 호출됨:', { forceUserMode, hasAdmin: hasAdminPermission(), hasManager: hasManagerPermission(), hasSystem: hasSystemPermission() });
    // 강제 사용자 모드가 활성화된 경우 일반 사용자 모드
    if (forceUserMode) {
      return false;
    }
    if (isEmbed()) {
      return false;
    }
    // 관리자 페이지에 있거나 관리자 권한이 있는 경우 관리자 모드
    if (
      hasAdminPermission() ||
      hasManagerPermission() ||
      hasSystemPermission()
    ) {
      return true;
    }
    return false;
  };


  // 관리자용 네비게이션 메뉴
  const adminNavItems = [
    { id: "dashboard", label: "대시보드", path: "/admin" },
    { id: "users", label: "사용자 관리", path: "/admin/users" },
    { id: "orders", label: "결제 관리", path: "/admin/orders" },
    { id: "delivery", label: "실물책 주문관리", path: "/admin/delivery" },
    { id: "coupons", label: "쿠폰 관리", path: "/admin/coupon" },
    // { id: "products", label: "상품 관리", path: "/admin/products" },
    // { id: "analytics", label: "통계 분석", path: "/admin/analytics" },
    // { id: "settings", label: "시스템 설정", path: "/admin/settings" },
  ];

  const onHandleLink = async (path: string) => {
    if (path) {
      navigate(path);
    }
    window.location.reload();
  };

  const handleLogoutClick = () => {
    logout();
    navigate("/");
    window.location.reload();
  };

  console.log(isAuthenticated);
  console.log(location);

  // 초기화가 완료되지 않았으면 아무것도 렌더링하지 않음
  if (!isInitialized) {
    return null;
  }

  // 모바일 환경에서는 헤더를 렌더링하지 않음
  if (isEmbed()) {
    return null;
  }

  console.log(isAdminPage());

  return (
    <>
      <header className={`header ${isAdminPage() ? "admin" : "user"}`}>
        <div className={`header_nav`}>
          <button className={`logo_box`} onClick={() => onHandleLink(`/`)}>
            <img src={`../contents/web_logo.png`} alt={`로그`} className={`logo`}/>
            <p>기억의 서랍</p>
          </button>
          <nav className={`header_btn_group`}>
            {!isAdminMode() && (
              <>
                {/*<button className={`btn btn-outline-primary body1 max-md:hidden`} onClick={()=>onHandleLink(`/contact`)}>비즈니스 문의</button>*/}
                <button className={`btn btn-primary body1 max-md:hidden`} onClick={() => onHandleLink(`/pricing`)}>
                  구매하기
                </button>
                
                {!isAuthenticated && (
                  <button className={`btn body1`} onClick={() => onHandleLink(`/login`)}>
                    로그인
                  </button>
                )}
                {isAuthenticated && (
                  <button className={`btn body1`} onClick={() => onHandleLink(`/mypage`)}>
                    마이페이지
                  </button>
                )}
              </>
            )}
            {isAdminMode() && (
              <>
                {isAdminPage() && (
                  <>
                    {adminNavItems?.map((nav, idx) => {
                      return (
                        <button key={idx} onClick={() => onHandleLink(nav?.path)}>
                          {nav?.label}
                        </button>
                      );
                    })}
                  </>
                )}
                {!isAuthenticated && (
                  <button className={`btn body1`} onClick={() => onHandleLink(`/login`)}>
                    로그인
                  </button>
                )}
                {isAuthenticated && (
                  <>
                    <button className={`btn body1`} onClick={() => onHandleLink(`/mypage`)}>
                      마이페이지
                    </button>
                    <button className={`btn body1`} onClick={handleLogoutClick}>
                      로그아웃
                    </button>
                  </>
                )}
              </>
            )}
          </nav>
        </div>
      </header>
    </>
  
  );
};

export default Header;
